if (!customElements.get('ofit-announcement')) customElements.define('ofit-announcement', class extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.ofit-announcement-item')];
    this.index = 0;
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.button = this.querySelector('button');
    this.updateButton();
    this.button?.addEventListener('click', () => {this.paused = !this.paused; this.updateButton();}, options);
    this.addEventListener('shopify:block:select', event => {
      const index = this.items.findIndex(item => item.contains(event.target));
      if (index >= 0) {this.show(index); this.paused = true; this.updateButton();}
    }, options);
    if(this.items.length > 1) this.timer = setInterval(() => {
      if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.show((this.index+1)%this.items.length);
    }, Number(this.dataset.interval)||5000);
  }
  show(index) {this.index=index;this.items.forEach((item,i)=>item.hidden=i!==index);}
  updateButton() {if(this.button){this.button.textContent=this.paused?'▶':'Ⅱ';this.button.setAttribute('aria-label',this.paused?'Play announcements':'Pause announcements');}}
  disconnectedCallback() {clearInterval(this.timer);this.controller?.abort();}
});
